module.exports = __webpack_public_path__ + "img/2.2f5c9a40.jpg";